/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { ArrowUpRight, Newspaper } from "lucide-react";
import { BLOG_BASE, FALLBACK_POSTS, POSTS_API, cleanTitle, normalizeImg } from "../components/BlogSection";

const BlogCard = ({ post, hidden }) => {
  const img = normalizeImg(post.featuredImage);
  const [failed, setFailed] = useState(false);
  return (
    <article className="mh-card mh-bcard" aria-hidden={hidden}>
      <div className="mh-bimg">
        {img && !failed ? (
          <img src={img} alt="" loading="lazy" width={420} height={229} onError={() => setFailed(true)} />
        ) : (
          <>
            <Newspaper size={22} aria-hidden="true" />
            JaaGa Insights
          </>
        )}
      </div>
      <div className="mh-bbody">
        <h3>{cleanTitle(post.title)}</h3>
        <p>{post.excerpt}</p>
        <a
          className="mh-bread"
          href={`${BLOG_BASE}/blogs/${post.slug}`}
          target="_blank"
          rel="noreferrer"
          tabIndex={hidden ? -1 : 0}
        >
          Read article
          <ArrowUpRight size={16} aria-hidden="true" />
        </a>
      </div>
    </article>
  );
};

const HomeBlog = () => {
  const [posts, setPosts] = useState(FALLBACK_POSTS);

  useEffect(() => {
    let active = true;
    fetch(POSTS_API)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        if (active && Array.isArray(data) && data.length) setPosts(data);
      })
      .catch(() => {
        /* keep the bundled fallback */
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <section className="mh-sec mh-bsec" aria-labelledby="mh-blog-h">
      <div className="mh-wrap">
        <div className="mh-head">
          <div className="mh-rule">
            <i aria-hidden="true" />
            <span>JaaGa Insights</span>
            <i aria-hidden="true" />
          </div>
          <h2 id="mh-blog-h">
            From our <span>Blog</span>
          </h2>
          <p>Simple guides, legal explainers, and state-by-state property tips from the JaaGa team.</p>
        </div>
        <div className="mh-strip">
          <div className="mh-track mh-btrack">
            {[...posts, ...posts].map((p, i) => (
              <BlogCard key={i} post={p} hidden={i >= posts.length} />
            ))}
          </div>
        </div>
        <div className="mh-ball">
          <a className="mh-cta" href={`${BLOG_BASE}/blogs`} target="_blank" rel="noreferrer">
            View all articles
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeBlog;
